/**
 * @name CommentLog
 * @description Bitácora de comentarios un backup
 * @author Ricardo Guerra
 */

import React from 'react';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';

import { EmployeeDetail } from '@tycommon/components';
import { Icons, Typography } from '@tycommon/styles';

const CommentLog = ({ photo, name, date, comment }) => {

  return (
    <Styled.FlexCol>
      <Styled.FlexRow>
        <EmployeeDetail
          avatar={photo ? photo : 'https://s3-us-west-1.amazonaws.com/ty-assets/icons/reconocimientos/aunporreconocer.png'}
          employeeName={name ? name : 'Talentry'}
        />
        <Styled.DateBox>
          <Icons.Date />
          <Typography.Small>
            {moment(date).format(i18n.t('FormatDates.short'))}
          </Typography.Small>
        </Styled.DateBox>
      </Styled.FlexRow>
      <Styled.FlexComment>
        <Styled.LineComment />
        {/* <Label>Comentario:</Label> */}
        <Typography.Text>{comment}</Typography.Text>
      </Styled.FlexComment>
    </Styled.FlexCol>
  );
};

CommentLog.propTypes = {
  // URL de la foto del empleado del comentario.
  photo: PropTypes.string,
  // Nombre del empleado del comentario.
  name: PropTypes.string.isRequired,
  // Fecha del comentario.
  date: PropTypes.string.isRequired,
  // Comentario.
  comment: PropTypes.string.isRequired,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
`;

Styled.FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 8px;
`;

Styled.FlexComment = styled.div`
  display: flex;
  padding: 0px 8px;
  margin-top: 8px;
`;

Styled.DateBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: auto;
  padding: 8px 0px 8px 8px;

  .MuiSvgIcon-root {
    margin-right: 8px;
    font-size: 18px;
  }
`;

Styled.LineComment = styled.div`
  margin: 0 20px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  background-color: ${(props) => props.theme.colors.greyLight};
`;

export default CommentLog;
